@if (message) {
  <h3>{{ message }}</h3>
}
<div class="rating">
  @if (showNumber) {
    <span
      ><strong>{{ _rating | number : "1.0-1" }}</strong></span
      >
    }
    @for (icon of stars; track icon) {
      <i [class]="icon"></i>
    }
  </div>
